import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DOOD_API } from '@config/ws.config';
import { PrepaymentUserBalance } from '@core/models/prepayment.model';
import { ShopTCPOSPlugin } from '@core/models/shop.model';

@Injectable({ providedIn: 'root' })
export class PrepaymentPluginApiService {
  private readonly httpClient = inject(HttpClient);

  loadUserBalance$({
    pluginType,
    shopId,
  }: {
    pluginType: ShopTCPOSPlugin['type'];
    shopId: string;
  }) {
    const params = new HttpParams().set('shopId', shopId);
    return this.httpClient.get<PrepaymentUserBalance>(
      `${DOOD_API}/plugins/${pluginType}/user-balance`,
      {
        params,
      },
    );
  }
}
